const ProductCmms = {
  FixedDeposit: 'fixed-deposit',
  Savings: 'savings',
  SharedCapital: 'shared-capital'
};

export default ProductCmms;
